module.exports = __webpack_public_path__ + "static/media/moon-cloud.dc2695a4.png";